(function () {
  'use strict';

  angular.module('web2print.shared')
  .directive('saveCampaignButton', saveCampaignButton);

  function saveCampaignButton () {
    return {
      restrict: 'E',
      templateUrl: 'components/shared/save-campaign-button/save-campaign-button.html',
      controller: SaveCampaignButtonController,
      controllerAs: 'vm'
    };
  }

  SaveCampaignButtonController.$inject = ['$location', 'progressTrackerFactory'];
  function SaveCampaignButtonController ($location, progressTrackerFactory) {
    const vm = this;

    vm.saveAndQuit = saveAndQuit;

    function saveAndQuit () {
      if (progressTrackerFactory.hasSavedCampaign()) {
        $location.path('/');
      }

      return;
    }
  }
})();
